import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { QUICKLAUNCH_INIT_LOADING, QUICKLAUNCH_INIT_SUCCESS, QUICKLAUNCH_INIT_FAIL, QUICKLAUNCH_ADD, QUICKLAUNCH_REMOVE } from '@/store/types'
import { extractMenu } from '@/utils/extract'

export const actions = {
  async initQuickLaunch({ commit, state }) {
    commit(QUICKLAUNCH_INIT_LOADING)
    const apiUrl = state.permitWidgets.quickLaunch
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(QUICKLAUNCH_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(QUICKLAUNCH_INIT_FAIL)
      }
    } else {
      commit(QUICKLAUNCH_INIT_FAIL)
    }
  },
  async addQuickLaunch(context, keyword) {
    const { commit, state } = context
    if (state.quickLaunch.init === 1) {
      // We will commit before calling the server to add quicklaunch
      // This will prevent user from seeing the delay (even if server fails to respond, at most user wont see the quicklaunch added by next visit)
      commit(QUICKLAUNCH_ADD, keyword)

      // Contact server to add quickLaunch
      const apiUrl = state.quickLaunch.menu.addQuickLaunch
      if (apiUrl) {
        try {
          const expand = {
            id: keyword
          }
          await http.post(expandURI(apiUrl, expand))
        } catch (error) { }
      }
    } else {
      Vue.prototype.$snotify.error('You need to enable Quick Launch feature in Dashboard')
    }
  },
  async removeQuickLaunch(context, keyword) {
    const { commit, state } = context
    commit(QUICKLAUNCH_REMOVE, keyword)

    // Contact Server to remove quickLaunch
    const apiUrl = state.quickLaunch.menu.removeQuickLaunch
    if (apiUrl) {
      try {
        const expand = {
          id: keyword
        }
        await http.delete(expandURI(apiUrl, expand))
      } catch (error) { }
    }
  }
}
